<template>
  <vs-popup :title="title" :active.sync="addNewDataLocal" @vs-close="closeForm">
    <vs-row vs-w="12">
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12">
        <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
          <label class="vs-input--label">Brand<sup>*</sup></label>
          <v-select
            @input="(x) => (vehicle_brand_id = x.value)"
            :clearable="false"
            :value="getSelectValue(vehicle_brand_id, brand_array)"
            :reduce="(x) => x.value"
            label="text"
            :options="brand_array" />
        </div>
        <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
          <label class="vs-input--label">Model Name</label>
          <div class="vs-con-input">
            <input
              type="text"
              v-model="model_name"
              name="model_name"
              class="vs-inputx vs-input--input normal"
              style="border: 1px solid rgba(0, 0, 0, 0.2)" />
          </div>
          <span></span>
        </div>
      </vs-col>
    </vs-row>

    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          class="mr-3 mb-2 btn-submit vs-con-loading__container"
          @click="submitsForm()"
          v-if="!editMode">
          Submit
        </vs-button>
        <vs-button
          class="mr-3 mb-2 btn-load-2 vs-con-loading__container"
          @click="updateForm"
          v-if="editMode"
          :disabled="status_awal == 0"
          >Update
        </vs-button>
        <vs-button
          color="danger"
          class="mr-3 mb-2 vs-con-loading__container"
          @click="takeOut"
          v-if="dataEdit.reff_vehicle_id != null"
          :disabled="status_awal == 0 && editMode"
          >Take Out
        </vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
    <vs-popup title="Take Out Reason" :active.sync="reasonPopUp">
      <vs-textarea
        placeholder="Please Write take out reason"
        v-model="description">
      </vs-textarea>
      <vs-divider />
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            color="danger"
            class="mr-3 mb-2 btn-load-3 vs-con-loading__container"
            :disabled="description == '' || disableTakeout"
            @click="takeOutProcess"
            >Process
          </vs-button>
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="reasonPopUp = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    allData: Array,
    dataEndPoints: Array,
    dataBrand: Array,
    dataCategory: Array,
    editMode: Boolean,
    dataEdit: Object,
  },
  components: {
    // Datepicker
  },
  data() {
    return {
      model_array: [],
      active_array: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
        {
          label: 'Suspend',
          value: 2,
        },
      ],
      brand_array: [],
      vehicle_brand_id: '',
      model_name: '',
      reasonPopUp: false,
      disableTakeout: false,
      end_points: [],
      description: '',
      status: 1,
      status_awal: 1,
    }
  },
  watch: {
    editMode(val) {
      if (val) {
        this.description = ''
        this.loadingBtnStop('btn-load-2')
        this.loadingBtnStop('btn-submit')
        if (this.dataEdit.brand) {
          //
          this.vehicle_brand_id = this.dataEdit.brand.id
        } else {
          //
          this.vehicle_brand_id = ''
        }
        this.model_name = this.dataEdit.model_name
        // this.status_awal = this.dataEdit.status
      } else {
        //
      }
    },
    s_alert(val) {
      // this.calculateFleet(val)
    },
  },
  mounted() {
    //
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (!this.editMode) this.clearFields()
        if (this.dataBrand.length > 0 && this.addNewData) {
          this.brand_array = []
          let tmp = []
          this.dataBrand.forEach((x) => {
            tmp.push({
              value: x.id,
              text: x.brand_name,
            })
          })
          this.brand_array = tmp
          //
        }

        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },

  methods: {
    autoCapitalize(val, vari) {
      vari = val.toUpperCase()
    },
    changeSelect(val) {
      //
    },

    ubah(val) {
      //
      this.status = val.nilai
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.loadingBtnStop('btn-submit')
      this.vehicle_brand_id = ''
      this.model_name = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    submitsForm() {
      this.loadingBtnStart('btn-submit')

      let dataForm = {
        brand_id: this.vehicle_brand_id,
        model_name: this.model_name,
        created_by: this.$dataLocal.UserData().name,
      }
      //
      REPO.postModel(dataForm)
        .then((res) => {
          this.loadingBtnStop('btn-submit')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.clearFields()
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          this.loadingBtnStop('btn-submit')
          //
          let datas = err.response.data
          let err_msg = ''
          let counter = 0
          for (var key in datas) {
            if (datas.hasOwnProperty(key)) {
              //
              err_msg += ' -' + datas[key]
            }
            counter++
          }
          if (counter === 0) {
            err_msg = err.message
          }
          this.$toast.error(err_msg)
        })
    },
    deleteData() {
      this.loadingBtnStart('btn-load-3')
      REPO.deleteVehicle(this.dataEdit.id)
        .then((res) => {
          this.clearFields()
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.error('Data Successfully Deleted')
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    takeOutProcess() {
      this.disableTakeout = true
      this.loadingBtnStart('btn-load-3')
      let param = {
        vehicle_id: this.dataEdit.id,
        license_plate: this.dataEdit.license_plate,
        vin: this.dataEdit.vin,
        fleet_group_id: this.dataEdit.fleet_group_id,
        description: this.description,
        machine_number: this.dataEdit.machine_number,
        imei_old: this.dataEdit.imei_obd_number,
        created_by: this.$dataLocal.UserData().name,
      }
      REPO.deleteModel(param)
        .then((res) => {
          this.clearFields()
          this.disableTakeout = false
          this.reasonPopUp = false
          this.loadingBtnStop('btn-load-3')
          this.$emit('submitModal', false)
          this.$toast.success('Data Successfully Take Out')
        })
        .catch((err) => {
          this.disableTakeout = false
          //
          this.loadingBtnStop('btn-load-3')
          this.$toast.error(err.message)
        })
    },
    takeOut() {
      this.reasonPopUp = true
    },
    updateForm() {
      this.loadingBtnStart('btn-load-2')
      let dataForm = {
        brand_id: this.vehicle_brand_id,
        model_name: this.model_name,
        created_by: this.$dataLocal.UserData().name,
      }
      //
      REPO.updateModel(dataForm, this.dataEdit.id)
        .then((res) => {
          this.loadingBtnStop('btn-load-2')
          if (res.data.status == 'true') {
            this.$emit('submitModal', false)
            this.clearFields()
            this.$toast.success('Data Successfullly Submitted')
          } else {
            this.$toast.error(res.data.error_msg)
          }
        })
        .catch((err) => {
          //
          this.loadingBtnStop('btn-load-2')
          let datas = err.response.data
          let err_msg = ''
          let counter = 0
          for (var key in datas) {
            if (datas.hasOwnProperty(key)) {
              //
              err_msg += ' -' + datas[key]
            }
            counter++
          }
          if (counter === 0) {
            err_msg = err.message
          }
          this.$toast.error(err_msg)
        })
    },
  },
}
</script>
<style>
.drop-height-auto .dropdown-toggle {
  height: auto !important;
  min-height: 38.5px;
}

sup {
  color: red;
}

.vdp-datepicker > div > input {
  background: transparent;
  width: 100% !important;
}
</style>
<style scoped>
.dropdown-toggle {
  height: auto;
  min-height: 38.5px;
}
</style>
